import React from 'react'
import { Link, graphql } from 'gatsby'
import get from 'lodash/get'
import Seo from "../global/Seo.js"
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import readingTime from 'reading-time'
import H1 from "../global/H1.js"
import Nav from '../global/menu/Nav'
import CookieContainer from '../global/cookies/CookieContainer'
import LayoutContainer from '../global/layout/LayoutContainer'
import { css } from 'glamor'
import { List, Divider, Grid, ListItem, Stack } from '@mui/material';
import { colours } from "../../constants/colourConstants";
import Footer from '../global/footer/Footer'
import { useSiteMetadata } from '../utils/useSiteMetadata.js'
import BlogArticleDetails from './BlogArticleDetails.js'
import BlogSocialShare from './BlogSocialShare.js'
import H4 from '../global/H4.js'
import Paragraph from '../global/Paragraph.js'
import _ from 'lodash'
import ArticleIcon from '../../images/Icons/article.svg'

const BlogPostTemplate = (props) => {
    const post = get(props, 'data.contentfulBlogPost')
    const previous = get(props, 'data.previous')
    const next = get(props, 'data.next')
    const plainTextDescription = documentToPlainTextString(
        JSON.parse(post.description.raw)
    )

    const plainTextBody = documentToPlainTextString(JSON.parse(post.body.raw))

    const timeToRead = readingTime(plainTextBody).text

    const pageUrl = `${useSiteMetadata().siteUrl}${props.location.pathname}`

    const ArticleListItem = ({ article, rel }) => {
        const { slug, author, title, description, publishDate } = article;
        const plainTextDescription = documentToPlainTextString(
            JSON.parse(description.raw)
        )
        const truncateDescription = _.truncate(plainTextDescription, { length: 80 })

        return (
            <ListItem disablePadding sx={{ margin: "0px" }}>
                <Link to={`/blog/${slug}`} rel={rel} {...css({ width: "100%" })}>
                    <Stack sx={{ width: "100%" }}>
                        <Stack
                            sx={{
                                padding: "16px 0px"
                            }}
                        >
                            <H4 {...css({ margin: "0 0 16px" })}>{title}</H4>
                            <div {...css({
                                fontSize: "14px",

                            })}>
                                <BlogArticleDetails
                                    authorName={author?.name}
                                    publishDate={publishDate}
                                    imageUrl={author.image?.url}
                                />
                            </div>
                        </Stack>
                        <Divider />
                    </Stack>
                </Link>
            </ListItem>
        )
    }

    return (
        <div>
            <Nav
                heroTemplate="lightHero"
            />
            <Seo
                passedTitle={post.title}
                passedDescription={plainTextDescription}
                image={post.heroImage?.url}
                location={props.location}
            />
            <LayoutContainer>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Link to="/blog">
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                        >
                            <img
                                src={ArticleIcon}
                                alt="All articles icon"
                            />
                            <span>All articles</span>
                        </Stack>
                    </Link>
                    <BlogSocialShare
                        pageUrl={pageUrl}
                    />
                </Stack>
                <Divider sx={{
                    marginBottom: 2,
                    marginTop: 3
                }} />
                <div
                    {...css({
                        color: colours.primary.greys[500],
                        fontSize: "14px",
                    })}>
                    <BlogArticleDetails
                        imageUrl={post.author.image?.url}
                        authorName={post.author?.name}
                        publishDate={post.publishDate}
                        timeToRead={timeToRead}
                    />
                </div>
                <article>
                    <H1
                        {...css({
                            marginTop: 32
                        })}
                    >
                        {post.title}
                    </H1>
                    <img
                        alt={post.title}
                        src={post.heroImage?.url}
                        {...css({
                            width: "100%",
                            height: 400,
                            objectFit: "cover",
                            marginBottom: 32,
                            borderRadius: "12px",
                        })}
                    />
                    <Grid container spacing={8}>
                        <Grid item md={8} sx={{ color: colours.primary.greys[600] }}>
                            <div>{post.body?.raw && renderRichText(post.body)}</div>
                        </Grid>
                        <Grid item md={4} sx={{ width: "100%" }}>
                            <Stack
                                spacing={4}
                            >
                                <div
                                    {...css({
                                        marginBottom: 0,
                                        fontSize: "14px",
                                        color: colours.primary.greys[500]
                                    })}
                                >
                                    Other articles
                                </div>
                                <List
                                    disablePadding
                                    sx={{
                                        marginTop: "0px !important",
                                    }}
                                >
                                    {previous && (
                                        <ArticleListItem article={previous} rel="prev" />
                                    )}
                                    {next && (
                                        <ArticleListItem article={next} rel="next" />
                                    )}
                                </List>
                            </Stack>
                        </Grid>
                    </Grid>
                </article>
            </LayoutContainer>
            <Footer />
            <CookieContainer />
        </div>
    )
}


export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug(
    $slug: String!
    $previousPostSlug: String
    $nextPostSlug: String
  ) {
    contentfulBlogPost(slug: { eq: $slug }) {
        slug
        title
        author {
            name
            image {
            url
            }
        }
        publishDate(formatString: "MMMM Do, YYYY")
        rawDate: publishDate
        heroImage {
            width
            height
            url
        }
        body {
            raw
        }
        description {
            raw
        }
    }
    previous: contentfulBlogPost(slug: { eq: $previousPostSlug }) {
        slug
        title
        description {
            raw
        }
        author {
            name
            image {
            url
            }
        }
        publishDate(formatString: "MMMM Do, YYYY")
        rawDate: publishDate
    }
    next: contentfulBlogPost(slug: { eq: $nextPostSlug }) {
        slug
        title
        description {
            raw
        }
        author {
            name
            image {
            url
            }
        }
        publishDate(formatString: "MMMM Do, YYYY")
        rawDate: publishDate
    }
  }
`